<template>
    <div id="pageTable">     
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="
                rol != 'root' && 
                rol != 'admin' && 
                rol != 'admin-empresa' &&
                rol != 'empleado'
                    
            "
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container> 
        <v-container xl fluid v-else>
            <v-row>
                <v-col cols="12" lg="12">
                    <data-table
                        ref="tabla"
                        :url="url"
                        :columns="columns"
                        :tableName="'Préstamos'"
                        :showAdvancedFilters="showOptions"
                        @loadModalData="loadModalData"
                        :filters="filters"
                        @setFilters="setFilters"
                        :perPage="[10,25,50,100]"
                    >
                        <template slot="actionButtonsLeft" v-if="showOptions">
                            <div class="botonAgregar" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>
                        <template slot="filters">
                            <template v-if="rol == 'root'">
                                <v-col xs="12" sm="12" md="12" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="itemsClientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value_filtro"
                                ></v-autocomplete>
                                </v-col>
                            </template>
                            <template v-if="rol == 'root' || rol == 'admin'">
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="itemsEmpresas"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Empresa"
                                        persistent-hint
                                        v-model="empresa_value"
                                    />
                                </v-col>
                            </template>
                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                    <v-autocomplete
                                        outlined
                                        :items="itemsSucursales"
                                        item-text="nombre"
                                        item-value="id"
                                        label="Sucursal"
                                        persistent-hint
                                        v-model="sucursal_value"
                                    />
                                </v-col>
                            </template>
                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <v-autocomplete
                                    outlined
                                    label="Empleados"
                                    :items="itemsEmpleados"
                                    item-text="nombre_completo"
                                    item-value="id"
                                    persistent-hint
                                    v-model="empleado_value"
                                    >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
                                <v-autocomplete
                                    outlined
                                    label="Tipo prestamo"
                                    v-model="tipo_incidencia_value"
                                    :items="deducciones"
                                    item-text="codigoNombre"
                                    item-value="id"
                                    persistent-hint
                                    class="pa-0 ma-0"
                                    required 
                                />
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    label="Fecha mínima"
                                    :valorDefecto="min_fecha"
                                    v-model="min_fecha"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaMinima"
                                />
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    label="Fecha máxima"
                                    :valorDefecto="max_fecha"
                                    v-model="max_fecha"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaMaxima"
                                />
                            </v-col>
                            
                        </template>
                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td v-if="rol!='empleado'"><div>{{item.nombre_completo}}</div></td>
                                <td><div>{{dateFormat(item.fecha_prestamo)}}</div></td>
                                <td><div>{{formatoMoneda(item.monto)}}</div></td>
                                <td><div>{{formatoMoneda(item.saldo)}}</div></td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="vista_abonos(item)">
                                                    <v-icon class="tamIconoBoton invertirColorBotones">description</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Abonos</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="rol!='empleado'">
                                            <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" class="botonHover" icon fab dark small @click="abrirModal('update', item)">
                                                <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                            </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <template v-if="permisos.delete">
                                            <v-tooltip bottom v-if="rol!='empleado'">
                                                <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="eliminar(item)">
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                                </template>
                                                <span>Eliminar</span>
                                            </v-tooltip>
                                        </template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>

            <template class="borde-card">
                <v-dialog v-model="dialog" persistent max-width="600px" class="borde-card" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>
                    <perfect-scrollbar style="background: #fff">
                        <v-card elevation="0" class="borde-card">
                            <ValidationObserver ref="form" v-slot="{ invalid }">
                                <v-card-title class="justify-center card_titulo">
                                    <div class="headerModal">
                                        <img :src="imagen" class="imgModal" />
                                        <h2 class="titleModal">{{ tituloModal }}</h2>
                                    </div>
                                </v-card-title>

                                <v-card-text class="card_texto">
                                    <div id="padre" v-show="isLoadingModal">
                                        <div id="loading">
                                            <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                        </div>
                                    </div>
                                    
                                    <v-container v-show="!isLoadingModal" grid-list-md id="contenedor">
                                        <v-divider class="divider"></v-divider>
                                        <v-row>
                                            <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Clientes" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Clientes"
                                                        :items="itemsClientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        persistent-hint
                                                        v-model="cliente_value"
                                                        class="pa-0 ma-0"
                                                        required 
                                                        :error-messages="errors" 
                                                        :disabled="accion == 'update' ? true:false"
                                                    >
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>

                                            <template v-if="rol == 'root' || rol == 'admin'">
                                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="itemsEmpresas"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Empresa"
                                                            persistent-hint
                                                            v-model="empresa_value"
                                                            required 
                                                            :error-messages="errors"
                                                            :disabled="accion == 'update' ? true:false"
                                                        />
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>

                                            <template v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'">
                                                <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                    <ValidationProvider v-slot="{ errors }" name="Sucursal" rules="required">
                                                        <v-autocomplete
                                                            outlined
                                                            :items="itemsSucursales"
                                                            item-text="nombre"
                                                            item-value="id"
                                                            label="Sucursal"
                                                            persistent-hint
                                                            v-model="sucursal_value"
                                                            required 
                                                            :error-messages="errors"
                                                            :disabled="accion == 'update' ? true:false"
                                                        />
                                                    </ValidationProvider>
                                                </v-col>
                                            </template>

                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Empleado" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Empleados"
                                                        :items="itemsEmpleados"
                                                        item-text="nombre_completo"
                                                        item-value="id"
                                                        persistent-hint
                                                        v-model="prestamo.empleado_id"
                                                        class="pa-0 ma-0"
                                                        required 
                                                        :error-messages="errors" 
                                                        :disabled="accion == 'update' ? true:false"
                                                    >
                                                    </v-autocomplete>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0 my-0">
                                                <ValidationProvider v-slot="{ errors }" name="Empleado" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        label="Tipo prestamo"
                                                        v-model="prestamo.tipo_incidencia_id"
                                                        :items="deducciones"
                                                        item-text="codigoNombre"
                                                        item-value="id"
                                                        persistent-hint
                                                        class="pa-0 ma-0"
                                                        required 
                                                        :error-messages="errors" 
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                                <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                    <v-text-field 
                                                        outlined
                                                        label="Descripción" 
                                                        class="pa-0 ma-0" 
                                                        v-model="prestamo.descripcion" 
                                                        :error-messages="errors" 
                                                        required
                                                    >
                                                    </v-text-field>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6"  class="py-0">
                                                <VuetifyDatePicker
                                                    outlined
                                                    rules="required"
                                                    v-model="prestamo.fecha_prestamo"
                                                    :valorDefecto="prestamo.fecha_prestamo"
                                                    label="Fecha de préstamo"
                                                    placeholder="dd/mm/aaaa"
                                                    ref="FechaPrestamo"
                                                />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                                <VuetifyMoneyValidate
                                                    outlined
                                                    rules="required"
                                                    label="Monto"
                                                    class="pa-0 ma-0"
                                                    prefix="$"
                                                    v-model="prestamo.monto"
                                                    v-bind:options="options"
                                                />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0 d-flex">
                                                <v-switch
                                                    v-model="prestamo.aplica_cobro"
                                                    label="Aplicar descuento"
                                                ></v-switch>
                                                <v-tooltip top class="pb-7">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                                    </template>
                                                    <span class="pb-7 textTooltip">
                                                        Si se selecciona la opción se le descontara <br>
                                                        automáticamente vía nómina
                                                    </span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                                <VuetifyMoneyValidate
                                                    outlined
                                                    label="Descuento"
                                                    class="pa-0 ma-0"
                                                    prefix="$"
                                                    v-model="prestamo.descuento"
                                                    v-bind:options="options"
                                                    :disabled="disableDescuento"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions class="d-flex justify-end card_accion">
                                    <button
                                        class="btnCerrar"
                                        @click="cerrarModal()" 
                                        :disabled="isSaving"
                                    >
                                        Cancelar
                                    </button>
                                    <v-btn
                                        class="btnGuardar"
                                        @click="guardar()" 
                                        :disabled="invalid" 
                                        :loading="isSaving"
                                        v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                    >
                                        Guardar
                                    </v-btn>
                                </v-card-actions>
                                <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                    <v-alert
                                        dense
                                        outlined
                                        type="error"
                                        
                                    >
                                        El usuario no tiene permiso para editar el registro.
                                    </v-alert>
                                </div>
                            </ValidationObserver>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </template>

        </v-container>
    </div>
</template>

<script>
import Datatable from "@/components/datatable/Datatable.vue";
import queries from '@/queries/Prestamos';
import Notify from '@/plugins/notify';
import apiClientes from '@/api/clientes';
import apiEmpresas from "@/api/empresas";
import apiSucursal from "@/api/sucursales"
import IncidenciasNominasApi from '@/api/nominas/incidencias';
import apiPrestamos from '@/api/nominas/prestamos';
import VuetifyMoneyValidate from '@/components/VuetifyMoneyValidate.vue';
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';


export default {
    components: {
        VuetifyDatePicker,
        VuetifyMoneyValidate,
        'data-table': Datatable,
    },
    data() {
        return {
            url:'prestamos/find',
            datosLogin      : null,
            rol             : null,
            columns         : [
                {
                    label: 'Empleado',
                    name: 'nombre',
                    filterable: false
                },
                {
                    label: 'Fecha',
                    name: 'fecha_prestamo',
                    filterable: true
                },
                {
                    label: 'Monto',
                    name: 'monto',
                    filterable: true
                },
                {
                    label: 'Saldo',
                    name: 'saldo',
                    filterable: true
                },
                {
                    label: 'Opciones',
                    name: 'opciones',
                    align:'center',
                    filterable: false
                }
            ],
            filters         : {
                cliente_id          : null,
                empresa_id          : null,
                empleado_id         : null,
                tipo_incidencia_id  : null,
                activo              : true,
                paginate            : true,
                order_by            : 'id',
                min_fecha           : null,
                max_fecha           : null,
            },
            tableData       : {},
            isLoading       : true,
            paginationData  : {
                numberItems : 10,
                numberPage  : 1
            },
            prestamo        : {
                id                  : null,
                cliente_id          : null,
                empleado_id         : null,
                tipo_incidencia_id  : null,
                descripcion         : null,
                monto               : null,
                fecha_prestamo      : null,
                aplica_cobro        : true,
                descuento           : 0,
            },
            accion          : null,
            tituloModal     : null,
            dialog          : false,
            isSaving        : false,
            imagen          : '',
            cliente_value   : null,
            cliente_value_filtro   : null,
            empresa_value   : null,
            sucursal_value  : null,
            empleado_value  : null,
            tipo_incidencia_value : null,
            fecha_prestamo  : null,
            min_fecha       : null,
            max_fecha       : null,
            itemsClientes   : [],
            itemsEmpresas   : [],
            itemsSucursales : [],
            itemsEmpleados  : [],
            empleado_type   : "add",
            menu            : false,
            menu_filter            : false,
            deducciones     : [],
            options: {
                locale: "es-MX",
                prefix: "$",
                suffix: "",
                length: 11,
                precision: 2
            },
            isLoadingModal  : false,
            disableDescuento : false,
            permisos :{
                create: false,
                update: false,
                delete: false,
            }

        }
    },
    computed:{
        showOptions: function(){
            if(this.rol == 'empleado'){
                return false;
            }
            else{
                return true;
            }
        }
    },
    watch : {
        cliente_value: function(val){
            
            if(val != null){
                this.getEmpresas(val);
                this.getTiposIncidencias(val);
            }
        },
        cliente_value_filtro: function(val){
            
            if(val != null){
                this.getEmpresas(val);
                this.getTiposIncidencias(val);
            }
        },
        empresa_value: function(val){
            if(val != null){
                this.getSucursales(val)
            }
        },
        sucursal_value: function(val) {
            if(val != null){
                this.getEmpleados(val);
            }
        },
        'prestamo.aplica_cobro': function(val){
            if(val){
                this.disableDescuento = false;
            }
            else{
                this.disableDescuento = true;
            }
        }
    },
    methods: {
        listar() {
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;

            if(this.rol == "empleado"){
                this.columns         = [
                    {
                        label: 'Fecha',
                        name: 'fecha_prestamo',
                        filterable: true
                    },
                    {
                        label: 'Monto',
                        name: 'monto',
                        filterable: true
                    },
                    {
                        label: 'Saldo',
                        name: 'saldo',
                        filterable: true
                    },
                    {
                        label: 'Opciones',
                        name: 'opciones',
                        align:'center',
                        filterable: false
                    }
                ]
            }

            if (this.rol == "root") {
                this.getClientes();
            }
            else if(this.rol == 'admin'){
                this.cliente_value_filtro = this.datosLogin.cliente_id;
                this.filters.cliente_id = this.datosLogin.cliente_id
            }
            else if(this.rol == 'empleado'){
                //this.filters.AND.push({column:'EMPLEADO_ID', value:this.datosLogin.empleado_id});
                this.filters.empleado_id = this.datosLogin.empleado_id
            }
            else {
                this.filters.cliente_id = this.datosLogin.cliente_id
                this.filters.empresa_id = this.datosLogin.empresa_id
            }
        },
        async abrirModal(accion, data = null){
            await this.resetValues();
            this.accion     = accion;
            this.isLoadingModal  = true;
            this.imagen     = "/static/icon/catalogos.png"
            this.empleado_type = "add";

            if(this.rol == 'root'){
                this.getClientes();
            }
            else if(this.rol == 'admin'){
                this.cliente_value = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            else{
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }


            if(accion == "add"){
                this.tituloModal    = "Registrar préstamo";
                this.imagen         = "/static/modal/prestamoCreate.svg";
                
            } else {
                this.tituloModal                    = "Actualizar préstamo";
                this.imagen                         = "/static/modal/prestamoUpdate.svg";
                this.prestamo.id                    = data.id,
                this.prestamo.cliente_id            = data.cliente_id;
                this.cliente_value                  = data.cliente_id;
                this.empresa_value                  = data.empresa_id;
                this.sucursal_value                 = data.sucursal_id;
                this.prestamo.empleado_id           = data.empleado_id;
                this.prestamo.tipo_incidencia_id    = data.tipo_incidencia_id;
                this.prestamo.descripcion           = data.descripcion;
                this.prestamo.monto                 = data.monto;
                this.prestamo.fecha_prestamo        = data.fecha_prestamo;
                this.prestamo.aplica_cobro          = data.aplica_cobro;
                this.prestamo.descuento             = data.descuento;
                setTimeout(()=>this.$refs.FechaPrestamo.setDate(data.fecha_prestamo),200);
            }
            this.isLoadingModal  = false;
            setTimeout(function(){ document.getElementById("btnModal").click(); }, 100);
        },
        
        async cerrarModal() {
            this.dialog     = false;
            this.isSaving   = false;
            await this.resetValues();
        },
        async resetValues() {
            this.prestamo       = {
                id                  : null,
                cliente_id          : null,
                empleado_id         : null,
                tipo_incidencia_id  : null,
                descripcion         : null,
                monto               : null,
                fecha_prestamo      : null,
                aplica_cobro        : true,
                descuento           : 0,
            }
            if(this.$refs.FechaPrestamo != undefined || this.$refs.FechaPrestamo != null){
                this.$refs.FechaPrestamo.resetDate();
            }
            if(this.$refs.FechaPrestamoBA != undefined || this.$refs.FechaPrestamoBA != null){
                this.$refs.FechaPrestamoBA.resetDate();
            }
            if (this.rol == "root") {
                this.cliente_value_filtro = null;
                this.cliente_value = null;
                this.empresa_value = null;
                this.sucursal_value= null;
                this.itemsEmpresas = [];
                this.itemsSucursales = [];
                this.itemsEmpleados = [];
                this.deducciones = [];
                
            }
            else if(this.rol == "admin"){
                this.empresa_value = null;
                this.sucursal_value= null;
                this.itemsSucursales = [];
                this.itemsEmpleados = [];
            }
            else if(this.rol == "admin-empresa"){
                this.empresa_value = null;
                this.sucursal_value= null;
                this.itemsSucursales = [];
                this.itemsEmpleados = [];
            }
            this.$nextTick(() => {
                if(this.$refs.form != null){
                    this.$refs.form.reset();
                }
                
                this.empleado_value = null;
                this.tipo_incidencia_value = null;
                this.fecha_prestamo = null;
                this.min_fecha      = null;
                this.max_fecha      = null;
            });
        },
        async loadModalData() {
            await this.resetValues();
            this.empleado_type = "consulta";
            if(this.rol == 'admin-empresa'){
                this.cliente_value_filtro = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
        },
        async setFilters() {
            
            let cliente = this.cliente_value_filtro;
            let empresa = this.empresa_value;
            let sucursal= this.sucursal_value;
            let empleado = this.empleado_value;
            let tipo_incidencia = this.tipo_incidencia_value;
            let min_fecha = this.min_fecha;
            let max_fecha = this.max_fecha;

            if (this.rol != "root") {    
                cliente = this.datosLogin.cliente_id;
            } 

            if (this.rol != "root" && this.rol != "admin") {    
                empresa = this.datosLogin.empresa_id;
            } 

            this.isLoading = true;

            let filterParams = {
                tipo_incidencia_id      : tipo_incidencia,
                min_fecha               : min_fecha,
                max_fecha               : max_fecha,
                cliente_id              : cliente,
                empresa_id              : empresa,
                sucursal_id             : sucursal,
                empleado_id             : empleado,
            };

            let defaultParams = {
                paginate    : true,
                activo      : true,
                order_by    : 'id',
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            //await this.resetValues();
        },
        eliminar(data){
            Notify.Alert(
                "¿Estás seguro de eliminar este préstamo?",
                "Esta acción <b>puede afectar</b> algunas funcionalidades del sistema.",
                "Eliminar",
                () => {
                    this.isLoading = true;
                    apiPrestamos.delete(data.id).then(response => {
                        Notify.Success("Préstamo eliminado", "El préstamo ha sido eliminado satisfactoriamente");
                        this.$refs.tabla.getData();
                    })
                    .catch(err => {
                        this.isLoading = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                },
                null,
                true,
                true
            )
        },
        guardar() {
            this.$refs.form.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }
                let descuento = parseFloat(this.prestamo.descuento);
                let monto = parseFloat(this.prestamo.monto);
                if(descuento > monto){
                    this.isSaving = false;
                    Notify.ErrorToast('El descuento tiene que ser menor o igual que el monto');
                    return;
                }
                this.prestamo.cliente_id = this.cliente_value;

                this.isLoading = true;
                if(this.accion === "add") {
                    apiPrestamos.store(this.prestamo)
                    .then((response) => {
                        Notify.Success("Operación exitosa", "El préstamo se guardó satisfactoriamente.");
                        this.$refs.tabla.getData();
                        this.cerrarModal();
                        this.$nextTick(() => {
                            this.$refs.form.reset();
                        });
                    })
                    .catch(err => {
                        this.isLoading = false;
                        this.isSaving = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
                else if(this.accion === "update") {
                    apiPrestamos.update(this.prestamo)
                    .then((response) => {
                        Notify.Success("Operación exitosa", "El préstamo se actualizó satisfactoriamente.");
                        this.$refs.tabla.getData();
                        this.cerrarModal();
                        this.$nextTick(() => {
                            this.$refs.form.reset();
                        });
                    })
                    .catch(err => {
                        this.isLoading = false;
                        this.isSaving = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            });
        },
        getClientes(){
            let parametros = { activo:true, paginate:false }
            apiClientes.getClientes(parametros).then((response) => {
                this.itemsClientes = response.data;
            })
            .catch(err => {
                console.log(err);
                Notify.ErrorToast("Ocurrió un error al cargar los Clientes.");
            });
        },
        async getEmpresas(cliente, accion = null) {
            let param = { activo: true, paginate: false, cliente_id: cliente };
            await apiEmpresas.getEmpresas(param).then((response) => {
                this.itemsEmpresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async getSucursales(empresa, accion = null) {
            let parametros = { activo: true, paginate: false, empresa_id: empresa };
            await apiSucursal.getSucursales(parametros).then((response) => {
                this.itemsSucursales = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        async getEmpleados(cliente) {
             if(cliente == null){
                return;
            } 
            
            let params = {};

            if(this.empleado_type == "add"){
                params = {
                    cliente_id : this.cliente_value,
                    empresa_id : this.empresa_value,
                    sucursal_id: this.sucursal_value,
                    tipo : this.empleado_type
                };

            }else if(this.empleado_type == "consulta"){
                params = {
                    cliente_id : this.cliente_value_filtro,
                    empresa_id : this.empresa_value,
                    sucursal_id: this.sucursal_value,
                    tipo : this.empleado_type
                };
            }

            await apiPrestamos.getEmpleados(params)
                .then(response => {
                    this.itemsEmpleados = response.data;
                })
                .catch(error => {
                    console.error(error)
                    Notify.ErrorToast("Ocurrió un error al cargar a los empleados.");
                });
        },
        async getTiposIncidencias(cliente) {
            if(cliente == null){
                return;
            } 

            let params = {
                cliente_id : cliente
            };
            this.deducciones = [];
            await apiPrestamos.getTiposPrestamos(params)
                .then(response => {
                    let format = response.data;
                    if(response.data.length != 0){
                        format.forEach( item => {
                            item.codigoNombre = item.codigo + ' - ' + item.nombre
                            this.deducciones.push(item);
                        })
                    }
                })
                .catch(error => console.error(error));
        },
        vista_abonos(data = null){
            this.$session.remove("datosPrestamo");
            this.$session.set('datosPrestamo',data);
            this.$router.push('/abonos');
        },
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },
        formatoMoneda(value){
            const formatter = new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
            })
            return formatter.format(value)
        },

         /**
         * @method redireccionar Método que redirecciona a una vista
         * @description Método que redirecciona a la vista dashboard si el no es root, admin
         */
        redireccionar(){
            this.$router.push('/dashboard');
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("prestamos.store")
            this.permisos.update = permisosStorage.includes("prestamos.update")
            this.permisos.delete = permisosStorage.includes("prestamos.destroy")
        },

    },
    created(){
        this.listar();
        this.permisosVista();
    },
    mounted(){

    },
}
</script>

<style scoped>
    #padre {
        padding-left: 40%;
    }
    #loading {
        display: table-cell;
        vertical-align: middle;
    }
    .botonModal.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
        display: none;
    }

</style>
